import Box from "@mui/material/Box";
import Drawer from "@mui/material/Drawer";
import { Theme } from "../data/style/Theme";
import { createContext, useContext, useState } from "react";

const DrawerContext = createContext();

export function DrawerProvider({ children }) {
  const [active, setActive] = useState(false);
  const [content, setContent] = useState(null);
  const toggleDrawer = (open) => {
    setActive(open);
  };

  let contextData = {
    toggleDrawer,
    setContent,
  };

  return (
    <DrawerContext.Provider value={contextData}>
      {children}
      <Drawer
        anchor={"right"}
        open={active}
        onClose={() => toggleDrawer(false)}
        transitionDuration={{ enter: 500, exit: 500 }}
      >
        <Box p={1} height={"100%"} sx={{ background: Theme.palette.bg }}>
          {content}
        </Box>
      </Drawer>
    </DrawerContext.Provider>
  );
}

export default function useDrawer() {
  return useContext(DrawerContext);
}
